import React, { useMemo } from 'react';
import { BsCalendar } from 'react-icons/bs';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import { getDateString } from '../../../utils/dateUtil';

const DocumentCard = ({ document }) => {
  const dateString = useMemo(() => getDateString(document.expiresAt, 'MM/DD/YYYY'), [document]);

  return (
    <Box
      _hover={{ boxShadow: 'hover2' }}
      borderRadius="10px"
      boxShadow="sharp4"
      flexBasis="100%"
      layerStyle="panel"
      mb={4}
      minH="100px"
      minW="480px"
      mr={4}
      mt={1}
      textAlign="left"
      w="100%"
    >
      <Box p={6}>
        <Text
          color={colors.greyScale['900']}
          mb={2}
          textStyle="bodyMd600"
        >
          {document.insuranceDocumentType.displayName}
        </Text>

        <HStack alignItems="flex-end" justifyContent="space-between">
          <Box>
            <Text
              color={colors.primaryScale['400']}
              textStyle="bodySm500"
            >
              File Name
            </Text>
            <Text textStyle="bodySm500">
              {document.displayName}
            </Text>
          </Box>

          <HStack>
            <Icon
              as={BsCalendar}
              boxSize="18px"
              color={colors.primaryScale['400']}
            />
            <Text textStyle="bodySm500">{dateString === '' ? 'N/A' : dateString}</Text>
          </HStack>
        </HStack>
      </Box>
    </Box>
  );
};

DocumentCard.propTypes = {
  document: PropTypes.shape({
    insuranceDocumentType: PropTypes.shape({ displayName: PropTypes.string }),
    displayName: PropTypes.string,
    expiresAt: PropTypes.string
  })
};

export default DocumentCard;
